import { selectedStore } from '@catalogo/core-graphql-cache';
import { fmtFreightDataForMetrics } from './freight';
import { fmtOption } from './freight-v2';

export const setInitialStore = data => {
  const store = data?.store?.capacity?.[0];
  selectedStore(store);
};

export const fmtStoreError = (storeError, data) => {
  const store = data?.store?.capacity;
  const notFound = store ? store.length === 0 : false;
  const hasError = storeError || notFound;

  if (hasError) {
    return {
      errorCode: 'STORE_NOT_FOUND',
    };
  }
};

export const fmtDeadline = (deadline, hours) => {
  const hasService = deadline !== null && deadline >= 0;

  if (!hasService) {
    return undefined;
  }

  switch (deadline) {
    case 0:
      return hours ? `em ${hours}` : 'hoje';
    case 1:
      return 'amanhã';
    default:
      return `em ${deadline} dias`;
  }
};

export const fmtNearFreightOptions = freight => {
  const options = freight?.options ?? [];
  const express = options.find(({ type }) => type.includes('EXPRESS'));
  const pnla = options.find(({ type }) => type === 'PICK_UP_IN_STORE_SCHEDULED');
  const pnl = options.find(({ type }) => type === 'PICK_UP_IN_STORE');
  const nearFreightOptions = [express, pnl ? pnl : pnla].filter(Boolean);
  const fmtNearFreightOptions = nearFreightOptions.map((option, index) => ({
    key: `option-${index}`,
    ...fmtOption(option),
  }));

  return fmtNearFreightOptions;
};

export const handleDispatchMetrics = ({ store, dispatchMetrics }) => data => {
  const error = data?.freight?.error;
  if ((!!store && !error) || (!store && !!error)) {
    dispatchMetrics('freight:event', fmtFreightDataForMetrics(data, 'lasa'));
  }
};
